
import dayjs from "dayjs";
import { Duration } from "dayjs/plugin/duration";

let currentId = 0;
export const generateId = (prefix: string = "id") => `${prefix}_${currentId++}`;

export function* range ( start: number, end: number, step = 1 ) {
	let state = start;
	while ( state <= end ) {
	  yield state;
	  state += step;
	}
	return;
};

export function formatDuration(duration?: Duration) {
	if (!duration)
		return "";

	const minutes = duration.minutes();
	const hours = duration.days() * 24 + duration.hours();

	return minutes > 9 ? `${hours}:${minutes}` : `${hours}:0${minutes}`;
}

export function validateBirthDate(dateString: string) {
	let str = dateString.replace(/\D/g, ""); //Ta bort allt som inte är siffror.
	if (str.length !== 6 && str.length !== 8)
		return null;
	if (str.length === 6) {
		let year = parseInt(str.slice(0,2));
		let currentYear = dayjs().year()-2000; //Obs, detta funkar bara fram till år 2099!
		if (year <= currentYear)
			str = "20" + str;
		else
			str = "19" + str;
	}

	const date = dayjs(str);
	if (date.isValid() && date.isSameOrBefore(dayjs(), "day"))
		return date;
	return null;
}